<template>
    <div>
        <q-modal v-model="show_question" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @show="clearQuestions()" @hide="hideQuestionModal()" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideQuestionModal()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('step') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <q-select v-model="question_type" :options="question_types" :float-label="$t('step_type')" :error="$v.question_type.$error" @input="$v.question_type.$touch" />
                        </div>
                    </div>

                    <q-table
                        :data="collection_question_alternatives"
                        :title="$t('alternatives')"
                        :columns="columns"
                        row-key="name"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[0]"
                        binary-state-sort
                        class="q-my-lg"
                        v-if="showTable"
                        >

                        <template slot="top" slot-scope="props">
                            <span>{{ $t('alternatives') }}</span>
                            <div class="col" />
                            <q-btn :color="$v.collection_question_alternatives.$error ? 'negative' : 'secondary'" icon="far fa-plus" :label="$t('new_f')" @click="editAlternative([])" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td key="title" :props="props">
                                {{ props.row.title }}
                            </q-td>

                            <q-td key="actions" :props="props">
                                <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="editAlternative(props.row)" />
                                <q-btn flat round color="negative" icon="far fa-trash-alt" @click="removeAlternative(props.row)" />
                            </q-td>
                        </q-tr>
                    </q-table>

                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <p class="caption">{{ $t('status') }}</p>
                            <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="hideQuestionModal()" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveQuestion()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="add_alternative" @ok="saveAlternative()" @hide="clearAlternative()">
            <span slot="title">{{ $t('alternative') }}</span>

            <span slot="body">
                <q-input v-model="new_alternative.title" @keyup.enter.native="saveAlternative()" />
            </span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('cancel')" @click="add_alternative = false" />
                <q-btn color="positive" :label="$t('save')" @click="saveAlternative()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'

export default {
    props: ['show_question', 'question'],

    data() {
        return {
            id: '',
            title: '',
            question_type: '',
            question_types: [
                { value: 1, label: this.$t('dissertative') },
                { value: 2, label: this.$t('single_choice') },
                { value: 3, label: this.$t('multiple_choices') },
                { value: 4, label: this.$t('upload') }
            ],
            collection_question_alternatives: [],
            columns: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            status: 1,
            statuses: [
                { label: this.$t('published'), value: 1 },
                { label: this.$t('unpublished'), value: 2 }
            ],
            add_alternative: false,
            new_alternative: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        showTable() {
            if (this.question_type == 2 || this.question_type == 3) return true
            else return false
        }
    },

    methods: {
        clearQuestions() {
            this.$v.$reset()
        },

        hideQuestionModal() {
            this.id = ''
            this.title = ''
            this.question_type = ''
            this.collection_question_alternatives = []
            this.status = 1

            this.$v.$reset()
            this.$emit('hide_question', '')
        },

        editAlternative(alternative) {
            if (alternative) {
                this.new_alternative.__index = alternative.__index
                this.new_alternative.title = alternative.title
                this.new_alternative.id = alternative.id
            }
            this.add_alternative = true
        },

        removeAlternative(alternative) {
            let objCopy = Object.assign([], this.collection_question_alternatives)
            this.collection_question_alternatives = []

            objCopy.splice(alternative.__index, 1)

            this.collection_question_alternatives = Object.assign([], objCopy)
        },

        saveAlternative() {
            let objCopy = Object.assign([], this.collection_question_alternatives)
            this.collection_question_alternatives = []

            if (this.new_alternative.__index != null) {
                objCopy[this.new_alternative.__index] = this.new_alternative
            }
            else objCopy.push(this.new_alternative)

            this.collection_question_alternatives = Object.assign([], objCopy)

            this.add_alternative = false
        },

        saveQuestion() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    title: this.title,
                    status: this.status,
                    question_type: this.question_type
                }

                if (this.question_type == 2 || this.question_type == 3) {
                    let question_alternatives = []

                    this.collection_question_alternatives.forEach(alternative => {
                        question_alternatives.push({ title: alternative.title })
                    })

                    data.question_alternatives = question_alternatives
                }

                if (this.question.id) {
                    this.$axios.put(`/admin_tasks/collections/${this.$route.params.id}/collection_questions/${this.question.id}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.hideQuestionModal()

                        this.$q.notify({
                            message: this.$t('question_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        this.hideQuestionModal()

                        this.$q.notify({
                            message: this.$t('question_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_tasks/collections/${this.$route.params.id}/collection_questions/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.hideQuestionModal()

                        this.$q.notify({
                            message: this.$t('question_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        this.hideQuestionModal()

                        this.$q.notify({
                            message: this.$t('question_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
        },

        clearAlternative() {
            this.new_alternative = []
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
    },

    watch: {
        show_question: function() {
            if (this.show_question && this.question) {
                this.id = this.question.id
                this.title = this.question.title
                this.question_type = this.question.question_type
                this.collection_question_alternatives = this.question.collection_question_alternatives
                this.status = this.question.status ? this.question.status : 1
            }
        }
    },

    validations() {
        return {
            title: { required },
            question_type: { required },
            collection_question_alternatives: {
                requiredIf: requiredIf(() => {
                    return this.showTable
                }),
                minLength: minLength(this.showTable && this.question_type == 2 ? 2 : 0)
            },
        }
    }
}
</script>

<style>

</style>
